import MobileTitleBar from "components/MobileTitleBar"
import OrderTable from "components/OrderTable/OrderTable"
import Price from "components/Price/Price"
import Badge from "components/Product/Badge"
import ProductFullscreen from "components/Product/ProductFullscreen"
import ProductImages from "components/Product/ProductImages"
import ProductPrice from "components/Product/ProductPrice"
import ProductQuantityGroup from "components/Product/ProductQuantityGroup"
import ProductPath from "components/ProductPath"
import Variants from "components/Variants/Variants"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React, {Component} from "react"
import Responsive from "react-responsive"
import {Link} from "react-router-dom"
import ButtonLove                                                                     from "components/Button/ButtonLove";
import {Breadcrumb, Button, Card, Container, Icon, Input, Loader, Message, Modal, Select, Table} from "semantic-ui-react"
import { ProductDownloads }                                                           from "components/ProductDownloads";

import shop from "shop/shop"

import productStore from "stores/productStore"
import settingStore from "stores/settingStore"
import "style/ProductPage.scss"
import ordinals from "theme/arnoldsports/sortParamsVariant"


const ProductAction = ( {product, onAdd} ) => {
	const [count, setCount] = React.useState( product.count )
	const list = shop.orderlist.default
	if ( !product ) return <div>Ungültiges Produkt</div>
	const veOptions = product.quantities.map( q => {
		return (
			{
				key  : q.map_desc_id,
				text : `${q.des} (${q.multi})`,
				value: q.map_desc_id
			}
		)
	} )
	return (
		<div className="ProductAction">

			{product &&
			<Input type="number" step={product.unit_multi} min={0} placeholder="1" value={count || ""} action
				   onBlur={(e => {
					   let ok = product.validateCount( e.currentTarget.value )
					   let value = e.currentTarget.value
					   let nearestValidCount = Math.round( value / product.unit_multi ) * product.unit_multi
					   if ( ok ) {
						   setCount( nearestValidCount )
					   }
				   })}
				   onChange={e => {
					   let ok = product.validateCount( e.currentTarget.value )
					   if ( ok ) setCount( e.currentTarget.value )
				   }
				   }>
				<input />
				<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[0].map_desc_id}
						onChange={( e, data ) => {
							const {value} = data
							const ve = product.quantities.filter( q => q.map_desc_id === value )
							if ( !ve ) return
							product.unit_multi = ve[0].multi
							product.unit_id = ve[0].map_desc_id
							console.log( {data, e, value: e.target.value, target: e.target} )
						}
						}
				/>
				<Button color={"black"} icon={"shopping cart"} onClick={() => {
					let nearestValidCount = Math.round( count / product.unit_multi )
					product.count = nearestValidCount

					console.info( "BUY", nearestValidCount, product.unit_multi, product.unit_id )
					onAdd( {product} )
				}
				} />
			</Input>
			}

		</div>
	)
}


export class OrderTableContainer extends Component {

	state = {
		byAttribute: false
	}

	componentDidMount() {
		const {product} = this.props
		console.log("this.props: ",this.props)
		if ( !product ) return

		productStore.partlist( product.mainart , true)
			.then( variants => {
				if ( !variants ) {
					console.error( "Keine Varianten gefunden ", {product} )
					return
				}
				console.log("variants: ", {variants} )
				const variantProtoypeByKey = {}

				let byAttribute = {}
				let variantMap = {}
				variants.variants.varfields.forEach( varfield => {

					let categories = _.groupBy( variants.products, `extraValue.${varfield}` )
					var ordered = {};
					// TODO: UNIFY
					_( categories ).keys().sort(
						( a, b ) => {
							let s0 = ordinals[a]
							let s1 = ordinals[b]
							return s0 >= s1 ? 1 : -1
						}
					).each( function ( key ) {
						ordered[key] = categories[key];
					} );
					byAttribute[varfield] = ordered
				} )

				let count = 0
				variants.products.forEach( product => {
					if ( !product.available ) return
					count++
					const hash = variants.variants.varfields
						.map( varfield => {
							const bucket = variantProtoypeByKey[varfield] || {}
							if ( !bucket[product.extraValue[varfield]] ) {
								bucket[product.extraValue[varfield]] = product
							}
							variantProtoypeByKey[varfield] = bucket

							return product.extraValue[varfield] || "null"
						} )
						.join( "___" )

					variantMap[hash] = product
				} )

				console.log( "variantProtoypeByKey", variantProtoypeByKey, {variantMap, count, count_all: variants.products.length} )
				this.setState( {variants, byAttribute, variantMap, variantProtoypeByKey} )
			} )
	}

	render() {
		const {product} = this.props
		const {byAttribute, variantProtoypeByKey, variantMap} = this.state
		return <div className={"OrderTableContainer cf"}>
			{byAttribute && <OrderTable style={{zIndex: 120}} isToggle={this.props.isToggle} product={product} byAttribute={byAttribute}
										variantProtoypeByKey={variantProtoypeByKey}
										variantMap={variantMap} />}

		</div>
	}
}


export default class ProductPage extends Component {

	componentWillUnmount() {
		document.body.classList.remove( "no-scroll" )
	}

	constructor( props ) {
		const {match} = props
		super()
		this.state = {
			showOrderTable   : shop.isToggle || false,
			id               : match.params.productId,
			product          : {},
			fullscreenElement: null,
			variants         : false
		}
		console.log("ProductPage::this.state: ",this.state)
	}

	toggleModal = () => {
		this.setState( {showOrderTable: !this.state.showOrderTable} )
	}

	loadProduct( id ) {
		if ( this.id === id ) return
		this.id = id
		productStore.get( id )
			.then( product => {
				console.log( "ProductPage::product", product ,"id", id)
				product.count = 1
				let inCart = shop.cart.productsById.get( product.map_id )
				if ( inCart ) product.count = Number( inCart.count )
				shop.analytics.push( product.map_id )
				// lastProducts = shop.analytics.lastProducts( 4 )
				//   .filter( ( id ) => id !== product.map_id )
				this.setState( {product: product, primaryImage: false} )

				if ( !product.mainart ) return
				productStore.partlist( product.mainart , true )
					.then( variants => {
						if ( !variants ) {
							console.error( "ProductPage: Keine Varianten gefunden ", {product} )
							return
						}
						const variantProtoypeByKey = {}

						let byAttribute = {}
						let variantMap = {}
						variants.variants.varfields.forEach( varfield => {

							let categories = _.groupBy( variants.products, `extraValue.${varfield}` )
							var ordered = {};
							// TODO: UNIFY
							_( categories ).keys().sort(
								( a, b ) => {
									let s0 = ordinals[a]
									let s1 = ordinals[b]
									return s0 >= s1 ? 1 : -1
								}
							).each( function ( key ) {
								ordered[key] = categories[key];
							} );
							byAttribute[varfield] = ordered
						} )

						let count = 0
						variants.products.forEach( product => {
							if ( !product.available ) return
							count++
							const hash = variants.variants.varfields
								.map( varfield => {
									const bucket = variantProtoypeByKey[varfield] || {}
									if ( !bucket[product.extraValue[varfield]] ) {
										bucket[product.extraValue[varfield]] = product
									}
									variantProtoypeByKey[varfield] = bucket

									return product.extraValue[varfield] || "null"
								} )
								.join( "___" )

							variantMap[hash] = product
						} )

						console.log( "variantProtoypeByKey", variantProtoypeByKey, {variantMap, count, count_all: variants.products.length} )
						this.setState( {variants, byAttribute, variantMap, variantProtoypeByKey} )
					} )
			} )
			.catch( error => {
				this.setState( {error} )
			} )
	}

	add = ( {product} ) => {
		//if ( product.count === 0 ) return shop.cart.remove( product )
		let ok = product.validateCount( product.count )
		if ( ok ) {
			shop.toast( translate( `toast.CART_ADD`, {total: product.unit_multi * product.count, title: product.title} ), "info", false, "top" )
			return shop.cart.add( product )
		} else {
			shop.toast( `<div>
<div>${translate( "Maximale Abnahmemenge erreicht" )}</div>
<div class="f6 ttu">${translate( "personalized_max_order_message", {value: product.stock} )}</div>
</div>`, "warning", false, "top" )
		}

	}

	updateProduct = ( {product} ) => {
		this.setState( {product} )
	}

	componentWillReceiveProps( {match} ) {
		console.log("match.params.productId: ",match)
		let {productId} = match.params
		this.loadProduct( productId )
	}

	showFullscreen = ( element ) => {
		this.setState( {
			fullscreenElement: element
		} )
	}

	setPrimaryImage = ( primaryImage ) => {
		this.setState( {primaryImage} )
	}

	componentDidMount() {
		console.log("this.state.id: ",this.state.id)
		this.loadProduct( this.state.id )
	}

	render() {
		let {showOrderTable, fullscreenElement, product, byAttribute, variantMap, primaryImage, variantProtoypeByKey} = this.state
		console.log("this.state: ",this.state)
		if ( !product._type ) return null //  duck type check for ProductModel
		let img_srcs = product.img_srcs

		let category = product.cats[0] && product.cats[0] || {}
		let cat_id = category.cat_id

		let productImage = false

		if ( product.img_src ) {
			productImage = product.img_src_large
		}

		if ( primaryImage ) productImage = primaryImage

		// let categoryName = shop.categoryName(product.cats[0].cat_id)
		let path = shop.getCategoryPath( cat_id )

		path.push( {
			title: product.title,
			link : ""
		} )

		// const veOptions = [
		//   { key: 'all', text: 'All', value: 'all' },
		//   { key: 'articles', text: 'Articles', value: 'articles' },
		//   { key: 'products', text: 'Products', value: 'products' },
		// ]

		const veOptions = product.quantities.map( q => {
			return (
			  {
				key: q.map_desc_id,
				text: `${q.des} (${q.multi})`,
				value: q.map_desc_id
			  }
			)
		  } )

		const mode = settingStore.get( "orderMode" )


		if ( !product.available ) return <Message>
			<div className="tc"> Dieses Produkt ist im Modus {translate( mode )} nicht verfügbar</div>
			{/*<pre>{JSON.stringify( product.extras, null, 2 )}</pre>*/}
		</Message>

		return (
			<div className="bg-white ">

				<MobileTitleBar>
					<ProductPath path={path} title={product.title} product={product} />
				</MobileTitleBar>

				<Container className="relative  ">
					<ProductFullscreen
						change={this.showFullscreen}
						images={img_srcs}
						image={fullscreenElement} />


					<div className="db pt2 pb1 ">
						<Breadcrumb>
							<Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>
							<Breadcrumb.Divider />
							{path.map( segment => {
								if ( !segment.link ) return <Breadcrumb.Section key={segment.title} active
																				style={{whiteSpace: "nowrap"}}>{segment.title}</Breadcrumb.Section>
								return <React.Fragment key={segment.title}>
									<Breadcrumb.Section link as={Link}
														to={segment.link}>{segment.title}</Breadcrumb.Section>
									<Breadcrumb.Divider />
								</React.Fragment>
							} )
							}

						</Breadcrumb>
					</div>


					<Responsive minWidth={790}>
						<div className="db pv3 ">
							<ProductPath path={path} title={product.title} product={product} /> <br />
						</div>
					</Responsive>


					{/*<Breadcrumbs path={path}/>*/}
					<section className="product product-single pb6-ns pb5">
						{/*<ProductPath path={path} title={product.title} product={product}/>*/}
						<tr>
							<td sm="1" md="1/2" lg="7/12" className="relative">
								<div className="absolute right-2 pr3"><Badge product={product} /></div>
								<ProductImages
									key={product.map_id}
									product={product}
									images={img_srcs}
									image={productImage}
									onClick={this.showFullscreen}
									onClickSecondary={this.setPrimaryImage} />
							</td>
							<td sm="1" md="1/2" lg="5/12">
								<TitleSection product={product} />
								{/*{shop.session && <ActionSection product={product}*/}
								{/*onChange={this.updateProduct}*/}
								{/*onAdd={this.add}/>*/}
								{/*}*/}

								{/*{shop.session && <ProductAction product={product}*/}
								{/*                                onAdd={this.add}*/}
								{/*/>}*/}


				{shop.session && <div className="ba b--black-20 pa3 bg-silver ">
                  <ProductPrice className={"f2 pb4 pt0 relative lh-solid"} product={product}/>
                  {(product && product.canBeBought) && <div>
                    {shop.session &&
                      <div className="product-actions">
                        {product &&
                          <Input type="number" min={0} placeholder="1" defaultValue={product.count} action onChange={e => {
                            this.setState( { count: e.target.value } )
                          }
                          }>
                            <input/>
                            <Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[ 0 ].map_desc_id}
                                    onChange={( e, data ) => {
                                      const { value } = data
                                      const ve = product.quantities.filter( q => q.map_desc_id === value )
                                      if ( !ve ) return
                                      product.unit_multi = ve[ 0 ].multi
                                      product.unit_id = ve[ 0 ].map_desc_id
                                      console.log( { data, e, value: e.target.value, target: e.target } )
                                    }
                                    }
                            />

                          </Input>
                        }
                        <div className="pt1 flex flex-row justify-between">
                          <Button primary onClick={() => {
                            product.count = this.state.count || 1
                            console.info( "BUY", this.state.count, product.unit_multi, product.unit_id )
							console.log("ProductPage::product", product)
                            this.add( { product } )
                          }
                          }>
                            <div className="ph3 ph4-ns flex flex-row items-center justify-center">
                              <Icon name={"shopping cart"}/>
                            </div>
                          </Button>
						  {/*shop.session && <div>
									{ eslint-disable-next-line react/jsx-no-undef }
									{product.mainart && <Button primary onClick={this.toggleModal} fluid><Icon name={"shopping cart"} /> {translate( "Varianten wählen" )}</Button>}
									{!product.mainart && <ProductAction product={product}
																		onAdd={this.add}
									/>}
								</div>*/}
                          <ButtonLove list={shop.orderlist.default}
                                      circular={false}
                                      className="dib mr3"
                                      elementInActive={<div className={"ph3 pv2"}><Icon name={"heart"}/> {translate( "Merkliste" )}</div>}
                                      elementActive={<div className={"ph3 pv2"}><Icon name={"heart"} className={"red"}/> {translate( "Merkliste" )}</div>}
                                      product={product}/>
                        </div>
                      </div>}

                  </div>}
                </div>}
				<br/>
				<section>
				<div className="ba b--black-20 pa3 bg-silver ">
									{<Variants style={{zIndex:100}} byAttribute={byAttribute} product={product} />}
									{/*{variants && variants.products && variants.products.map( variant => <ProductVariant key={variant.map_id} product={variant}/> )}*/}
									{/*<pre>{JSON.stringify( variants && variants.variants.varfields, null, 2 )}</pre>*/}
									</div></section>

								<DescriptionSection product={product} />
								{shop.session && <BulkPricing product={product} />}
								{!shop.session && <div>
									<p>
										{translate( "shop.please_login_for_product_details" )}
									</p>

									<div className="mw6">
										<div className="pb2">
											<Link to="/login"><Button fluid> {translate( "shop.login" )}</Button></Link>
										</div>
										<Link to="/customer_registration"><Button
											fluid> {translate( "shop.register" )}</Button></Link>
									</div>
								</div>}
								{shop.session && <TechnicalTable product={product} />}
								<br />
								<br />
								<section>
									{/*<Variants byAttribute={byAttribute} product={product} />*/}
									{/*{variants && variants.products && variants.products.map( variant => <ProductVariant key={variant.map_id} product={variant}/> )}*/}
									{/*<pre>{JSON.stringify( variants && variants.variants.varfields, null, 2 )}</pre>*/}
								</section>
							</td>
						</tr>
					</section>


					{!byAttribute && <Loader />}

					{showOrderTable && <Modal style={{paddingTop: "5%", paddingBottom: "2%"}} open size={"fullscreen"}>
						<Modal.Header>
							{product.desc.short_des.split( "," )[0]} 
							<div className="absolute right-1 top-1"><Button basic circular icon="times" onClick={this.toggleModal} /></div>
						</Modal.Header>
						<Modal.Content className={"relative"}>
							<OrderTableContainer isToggle={showOrderTable} product={product} key={product.map_id} />
							<div className="absolute bottom-1 left-1">
								<Button basic onClick={this.toggleModal}>{translate( "Zurück" )}</Button>
							</div>
						</Modal.Content>
					</Modal>}

					{byAttribute && <div className="pb5">
						<div className={"overflow-hidden cf"}>
							{/*<div className={"f3 fw3 tc pt2 pb4 "}>Jetzt bestellen</div>*/}
							{console.log("byAttribute ProductPage: ", byAttribute)}
							{byAttribute && <OrderTable style={{zIndex: 120}} product={product} byAttribute={byAttribute}
														variantProtoypeByKey={variantProtoypeByKey}
														variantMap={variantMap} />}
						</div>
					</div>}

					{/* DEBUG */}

				</Container>


				{document.location.search.indexOf( "debug" ) >= 0 && <Container>
					<pre>{JSON.stringify( product, null, 2 )}</pre>
				</Container>}


				{/*{product.extras.Kollektion && <div className="bg-silver pv4">*/}
				{/*<Container>*/}
				{/*<section className=" pt3 pb5">*/}

				{/*<div className="cf relative pb3">*/}
				{/*{product.category.desc &&*/}
				{/*<Link to={
    `/collection-extra/Kollektion/${product.extras.Kollektion}`
  }><h2*/}
				{/*className="mt2 ttu">{
    `${translate("Mehr aus Kollektion")}  ${product.extras.Kollektion}`
  } <Icon*/}
				{/*name="chevron right"/></h2>*/}
				{/*</Link>}*/}
				{/*</div>*/}

				{/*<ProductSearchExtra*/}
				{/*count={4}*/}
				{/*start={0}*/}
				{/*extra={"Kollektion"}*/}
				{/*extraValue={product.extras.Kollektion}*/}
				{/*query="%%"*/}
				{/*repeat={ProductCard}/>*/}
				{/*</section>*/}

				{/*</Container>*/}
				{/*</div>}*/}

				{/*{product.category && <div className="pv4">*/}
				{/*<Container>*/}
				{/*<section className="section-product-slider">*/}
				{/*<div className="cf relative pb3">*/}
				{/*{product.category.desc && <Button basic as={Link} to={
    `/collection/${product.category.map_id}`
  }><h2*/}
				{/*className="mt2 ttu">{`${translate("Mehr aus")} ${product.category.desc.des ||*/}
				{/*product.category.desc.short_des}`} <Icon name="chevron right"/></h2>*/}
				{/*</Button>}*/}
				{/*</div>*/}

				{/*<ProductSearch*/}
				{/*count={4}*/}
				{/*start={0}*/}
				{/*cats={[ cat_id ]}*/}
				{/*query="%%"*/}
				{/*repeat={ProductCard}/>*/}
				{/*</section>*/}
				{/*</Container>*/}
				{/*</div>}*/}

				{/*<div className="pv4 bg-silver">*/}
				{/*<Container>*/}
				{/*/!*Product Slider "last viewed"*!/*/}
				{/*<section className="section-product-slider pv5">*/}
				{/*<h2 className="mt2  ttu">{translate("Zuletzt angesehen")}</h2>*/}
				{/*<ProductList*/}
				{/*count={4}*/}
				{/*start={0}*/}
				{/*list={lastProducts}*/}
				{/*repeat={ProductCard}/>*/}
				{/*</section>*/}
				{/*</Container>*/}
				{/*</div>*/}

			</div>
		)
	}
}

ProductPage.propTypes = {
	price: PropTypes.any
}


const ProductVariant = ( {product} ) => {
	return (
		<Card as={Link} to={`/product/${product.map_id}`}>
			<img className="ui image" src={product.img_src_medium} />
			<div>{product.extraValue.Art}</div>
			<div>{product.extraValue.Groesse}</div>
		</Card>
	)
}

const BulkPricing = ( {product} ) => {
	if ( !product.prices || product.prices.length === 1 ) return null
	return (

		<div>
			<h4>{translate("Staffelpreise")}</h4>
			<Table>
				<tbody>
				{product.prices.map( price => (
					<tr key={price.q}>
						<td>{translate("ab")} {price.q} {translate("Stück")}</td>
						<td><Price>{price.p}</Price></td>
					</tr>
				) )}
				</tbody>
			</Table>

		</div>
	)
}

const Fullscreen = ( {image, change, images} ) => {
	document.body.classList.remove( "no-scroll" )
	if ( !image ) {
		return null
	}
	window.scrollTo( 0, 0 )
	const imgs = _.map( images, ( {img_src_large, img_src_small}, key ) => {
		return (
			<img key={key}
				 alt={""}
				 onClick={() => {
					 change( img_src_large )
				 }}
				 className="img-thumbnail "
				 src={img_src_small} />
		)
	} )

	document.body.classList.add( "no-scroll" )
	return (
		<div className="fullscreen">
			<div className="ui pull-right"
				 style={{position: "relative"}}>
				<Button icon="close"
						basic
						onClick={() => {
							change( false )
						}} />
			</div>

			<div className="center-child"
				 onClick={() => {
					 change( false )
				 }}>
				<div className="zoom-out img-container">
					<img src={image} alt="" />
				</div>
			</div>

			<div className="ui ui-bottom pull-right ">
				<div className="product-images">
					{imgs}
				</div>
			</div>
		</div>
	)
}

Fullscreen.propTypes = {
	children: PropTypes.object, change: PropTypes.func, images: PropTypes.array
}

const TechnicalTable = ( {product} ) => {
	const mode = settingStore.get( "orderMode" )
	return (
		<div className="pt4">
			<Table basic="very" compact striped>
				<Table.Body>
					{product.quantities.map( q => {
						return (
							<Table.Row key={q.map_desc_id}>
								<Table.Cell width={5}>
									<label className={"fw2 black-60 f5"}>
										{translate( "VE" )} ({q.des})
									</label>
								</Table.Cell>
								<Table.Cell>
									{q.multi} {/*translate(product.baseUnitDisplayName)*/}
								</Table.Cell>
							</Table.Row>
						)
					} )}

					<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "Artikel Nr." )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.article_nr}
						</Table.Cell>
					</Table.Row>

					{/*<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "UVP" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							<Price>{mode == 'MODE_PREORDER' ? product.extraValue.uvp_vororder : product.extraValue.uvp}</Price>
						</Table.Cell>
				</Table.Row>*/}

					{product.extraValue.Variante && <Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "Variante" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{(product.extraValue.Variante === "null" || product.extraValue.Variante === null) ? "uni" : product.extraValue.Variante}
						</Table.Cell>
					</Table.Row>}


					{(product.extraValue.verfuegbarab === "null" || product.extraValue.verfuegbarab === null) &&
					<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "Verfügbar ab" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{moment( product.extraValue.verfuegbarab, "DD-MM-YYYY" ).format( "DD. MMM YYYY" )}
						</Table.Cell>
					</Table.Row>
					}

					{/*<Table.Row>*/}
					{/*<Table.Cell>*/}
					{/*<label className={"fw2 black-60 f5"}>*/}
					{/*Größe*/}
					{/*</label>*/}
					{/*</Table.Cell>*/}
					{/*<Table.Cell>*/}
					{/*{product.extras.groesse}*/}
					{/*</Table.Cell>*/}
					{/*</Table.Row>*/}

					<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "Marke" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.extraValue.Markenname}
						</Table.Cell>
					</Table.Row>

					{product.extraValue.Herstellername &&<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "Herstellername" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.extraValue.Herstellername}
						</Table.Cell>
					</Table.Row>}

					{product.extraValue.Herstellerartikelnummer &&<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "Herstellerartikelnummer" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.extraValue.Herstellerartikelnummer}
						</Table.Cell>
					</Table.Row>}

					{product.extraValue.Zeigerumdrehung_1 &&<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "1 Zeigerumdrehung" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.extraValue.Zeigerumdrehung_1}
						</Table.Cell>
					</Table.Row>}

					{product.extraValue.Ablesung &&<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "Ablesung " )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.extraValue.Ablesung}
						</Table.Cell>
					</Table.Row>}

					{product.extraValue.Außen_Durchmesser &&<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "Außen-Ø" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.extraValue.Außen_Durchmesser}
						</Table.Cell>
					</Table.Row>}

					{product.extraValue.Typ &&<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "Typ" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.extraValue.Typ}
						</Table.Cell>
					</Table.Row>}

					{product.extraValue.WGNr &&<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "WGNr. " )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.extraValue.WGNr}
						</Table.Cell>
					</Table.Row>}

					{product.salePercent &&
					<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "Rabatt" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.salePercent}
						</Table.Cell>
					</Table.Row>
					}

					<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								EAN
							</label>
						</Table.Cell>
						<Table.Cell>
							{product.barcode}
						</Table.Cell>
					</Table.Row>

					{product.extraValue.variante2 &&<Table.Row>
						<Table.Cell>
							<label className={"fw9 f5"}>
								{translate( "Artikelart" )}
							</label>
						</Table.Cell>
						<Table.Cell className={"fw9  f5"}>
							{product.extraValue.variante2}
						</Table.Cell>
					</Table.Row>}

					{product.extraValue.variante1 &&<Table.Row>
						<Table.Cell>
							<label className={"fw9 black f5"}>
								{translate( "Größe " )}
							</label>
						</Table.Cell>
						<Table.Cell className={"fw9 black f5"}>
							{product.extraValue.variante1}
						</Table.Cell>
					</Table.Row>}

				</Table.Body>
			</Table>
			{shop.session && <div className="pt3 pt4-ns">
                  <ProductDownloads product={product}/>
                </div>}
		</div>
	)
}

TechnicalTable.propTypes = {
	product: PropTypes.object
}

const AdditionalTable = ( {product} ) => {
	return (
		<section className="AdditionalTable">
			<tr>
				<td sm="1" md="1" className="pb3">
					<div className="technischetabelle">
						<strong>weitere Details</strong>
						<table className="table-technical">
							<tbody>

							{product.barcode && <tr>
								<td>EAN</td>
								<td className="text-right">{product.barcode}</td>
							</tr>}
							</tbody>
						</table>
					</div>
				</td>
			</tr>
		</section>
	)
}

AdditionalTable.propTypes = {
	product: PropTypes.object
}

const TitleSection = ( {product} ) => (
	<section className="product-title mb0 pb0">
		<div className="brand">{product.extraValue.herst !== "unbekannt" &&
		<Link to={`/brand/${product.extraValue.herst}`}>{product.extraValue.herst}</Link>}</div>
    <div className="title f3 f2-ns b lh-copy">{product.desc.short_des}</div>

{/*<div className="title f1 b lh-copy">{product.desc.des}</div>*/}
<div className="id pt2 pb2 pv2">{product.article_nr || product.article_id}</div>
		{/*shop.session && <ProductPrice product={product} />*/}
		{/* Availability*/}
		{/*<Availability product={product}/>*/}
	</section>
)

TitleSection.propTypes = {
	product: PropTypes.object
}

const Availability = ( {product} ) => {
	let notice = product.getNotice()
	return (
		<div className="availability">
			{notice}
		</div>
	)
}

const ActionSection = ( {product, onChange, onAdd} ) => {
	if ( !product.canBeBought ) return null
	const list = shop.orderlist.default
	return (
		<section className="product-actions pt2 pb4">
			<div style={{display: "inline-block "}}>
				<p>
					{product.count * product.unit_multi} {translate( "Stück" )} <Price
					className="f5 fw2 black-50">{product.count * product.unit_multi * product.price}</Price></p>
				<ProductQuantityGroup product={product}
									  list={list}
									  showVE={false}
									  onChange={onChange}
									  onAdd={onAdd}
									  large />
			</div>
		</section>
	)
}

ActionSection.propTypes = {
	product : PropTypes.object,
	onChange: PropTypes.func,
	onAdd   : PropTypes.func,
}

const DescriptionSection = ( {product} ) => (
	<section className="description pv3 lh-copy">
		{/*product.desc.des*/}
		{product.desc.des.split("\n").map((line, index) =>(
			<div key={index}>{line}</div>
		))}
	</section>
)
DescriptionSection.propTypes = {
	product: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/theme/lindt/pages/ProductPage.js